import { endsWith } from "ramda";

// TODO: once we have an actual role system, we should do a better check. This
// function should *NOT* be relied upon for security. The backend should not
// return data that the logged in user doesn't have permission to see. Instead,
// this function should be used for providing a better UX to non super users
// when they visit super user pages.
export function isSuperUser(email: string): boolean {
  return (
    endsWith("@swipely.com", email) ||
    endsWith("@upserve.com", email) ||
    endsWith("@lightspeedhq.com", email)
  );
}
